import { ITextValue } from '@/types/common';
import { PropertyBuildingUnitMixEnum, PropertyBuildingUnitMixLabels } from '@/bundles/Property/enums/building/unitMix';
import { PropertyBuildingStyleEnum, PropertyBuildingStyleLabels } from '@/bundles/Property/enums/building/style';
import {
  PropertyBuildingMarketSegmentEnum,
  PropertyBuildingMarketSegmentLabels
} from '@/bundles/Property/enums/building/marketSegment';

export const getPropertyBuildingUnitMixTextValues = (): ITextValue<PropertyBuildingUnitMixEnum>[] => {
  return Object.keys(PropertyBuildingUnitMixLabels).map((key) => {
    return {
      text: PropertyBuildingUnitMixLabels[key],
      value: key as PropertyBuildingUnitMixEnum,
    };
  });
}

export const getPropertyBuildingStyleTextValues = (): ITextValue<PropertyBuildingStyleEnum>[] => {
  return Object.keys(PropertyBuildingStyleLabels).map((key) => {
    return {
      text: PropertyBuildingStyleLabels[key],
      value: key as PropertyBuildingStyleEnum,
    };
  });
}

export const getPropertyBuildingMarketSegmentTextValues = (): ITextValue<PropertyBuildingMarketSegmentEnum>[] => {
  return Object.keys(PropertyBuildingMarketSegmentLabels).map((key) => {
    return {
      text: PropertyBuildingMarketSegmentLabels[key],
      value: key as PropertyBuildingMarketSegmentEnum,
    };
  });
}
